.root {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 300px;

  &.compact {
    min-height: 50px;
  }

  &.editable {
    cursor: pointer;
  }
}

.main {
  position: relative;
  flex-grow: 1;
  padding: 0.75rem;
  overflow: auto;
  background: var(--widget-background);
  border: 1px solid var(--widget-header-background);

  &.hideOverflow {
    overflow: hidden;
  }
}

.tight {
  padding-top: 0;
}

.compact {
  padding-top: 0;
  border-top: none;
}

.header {
  position: relative;
  padding: 0.75rem;
  background-color: var(--widget-header-background);

  .compact & {
    display: none;
  }

  .mirrored {
    color: var(--gray-600);
  }
}

.edit {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  transform: translateY(-50%);

  @media (--sm-down) {
    display: none;
  }
}

.title {
  font-weight: var(--font-weight-regular);
  color: var(--widget-header-color);
}

.description {
  color: var(--widget-subheader-color);
}

.loading,
.noData,
.error {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: var(--font-size-body-2);
  text-align: center;
  transform: translate(-50%, -50%);
}

.wrapper {
  display: flex;
  width: 100%;
  height: 100%;
}

.column {
  flex-direction: column;
}
